<template>
  <div>
      <Nav></Nav>
       <div class="mased" >
    <div class="w">
   <div class="juqerbar">
        <div class="main_jquers_header">
          <img src="../assets/img/pintai.png"  ref="mdidest" alt="">
        <!-- <a href="">  平台优势</a> -->
      </div>
      <div class="Plat">
        <!-- Platform Advantages -->
      </div>
      <div class="number">
      <ul>
        <li>
          <img src="../assets/image/one.png" alt="">
        </li>
         <li>
          <img src="../assets/image/two.png" alt="">
        </li>
         <li>
          <img src="../assets/image/three.png" alt="">
        </li>
         <li>
          <img src="../assets/image/four.png" alt="">
        </li>

      </ul>

      </div>
      <div class="main_jquers_main">
          <ul>
            <li v-for="(item,index) in requers" :class="{'mainst':item.id===crrId}" @mousemove="mainjquers(item)" :key="index">

            <div class="post">
                <img :src="item.img" alt="">
            </div>
              <p>{{item.name}}</p>
              <span>{{item.desc}}</span>
            </li>

          </ul>
      </div>

   </div>
  </div>
  </div>
  <Footer></Footer>
  </div>
</template>

<script>
import img3 from '../assets/image/ico1.png'
import img4 from '../assets/image/ico4.png'
import img5 from '../assets/image/ico3.png'
import img6 from '../assets/image/ico2.png'
import Nav from '../components/Nav'
import Footer from '../components/Footer'

export default {
  components: {
    Nav,
    Footer
  },
  data () {
    return {
      crrId: '',
      requers: [
        { id: 1, img: img3, name: '移动大数据平台', desc: '基于移动大数据，提供信息流广告优选解决方案,多唯定向，精准触达，以实现跨平台数据复用' },
        { id: 2, img: img4, name: '专业运营优化', desc: '独家优化方案及测试体系，专业王盘优化师，标准高效一体化' },
        { id: 3, img: img5, name: '海量需求库', desc: '一对一的客服需求对接，及时充分了解客户需求，并具备专业的商业思维分析及成熟的技术支持' },
        { id: 4, img: img6, name: '高效标准服务', desc: '安全的技术，保证了非人类流量的过滤，媒体环境的定向，LBS跨屏定向可在全国内指定商圈，定向投放' }
      ]
    }
  },
  methods: {
    mainjquers (item) {
      this.crrId = item.id
    }
  }
}
</script>

<style lang="scss" scoped>
 .mased {
     margin-top: 100px;
      // background-color: #fff;
       background: url(../assets/image/ma.png) no-repeat ;
      // background: url(../assets/image/one.png) no-repeat ;
      background-position: 0 415px;
  .w {
      .juqerbar {
           margin-top: 55px;
        .number {
          position: relative;
          ul {
              display: flex;
            li {
              &:nth-child(2) img {
                width: 60px;
                height: 83px;
                  position: absolute;

                left: 423px;
              }
               &:nth-child(3) img {
                width: 62px;
                height: 84px;
                  position: absolute;

                left: 730px;
              }
               &:nth-child(4) img {
                width: 66px;
                height: 81px;
                  position: absolute;

                left: 1030px;
              }
              img {
                width: 44px;
                height: 81px;
                display: inline-block;
                position: absolute;
                top: 70px;
                left:110px;

              }
            }
          }
        }

          .main_jquers_header {
            width: 121px;
            height: 87px;
            font-size: 26px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            cursor: pointer;
            line-height: 19px;
            margin: 0 515px;
           text-align: center;
           img {
             width: 179px;
             height: 87px;
           }
           a {
             color: #333333;
             &:hover {
               border-bottom: 5px solid #046AFF;
             }
           }
     }
     .Plat {
       text-align: center;

     }
     .main_jquers_main {
       position: relative;
        height: 430px;
       .mainst {
         background-color: #357FEC;
         color: #fff ;

       }
       margin-top: 150px;

       ul {
         display: flex;
         li {

           cursor: pointer;
           width: 277px;
           height: 370px;
           background: #FFFFFF;
           box-shadow: 0px 4px 12px 1px rgba(159, 189, 219, 0.3);
           border-radius: 12px;
           margin-right: 30px;

  .post {
          width: 90px;
          height: 90px;
         background-color: #fff;
          margin:40px 109px 48px 95px ;
          border-radius: 50%;
            img {
             width: 57px;
             height: 55px;
             display: inline-block;
             margin-top: 19px;
             margin-left: 15px;
           }
       }
           p {
             width: 159px;
             height: 21px;
             font-size: 20px;
             font-family: Microsoft YaHei;
             font-weight: bold;
             line-height: 32px;
              text-align: center;
             margin: 24px auto;
           }
           span {
             display: block;
             width: 179px;
              height: 108px;
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;

              line-height: 23px;
              margin: 0 auto;
           }
         }
       }

     }
     .main_jquers_footer {
       text-align: center;
     }
      }
    }
    }
</style>
